(function (host, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else factory().mount(host.document, () => host.PictoMiniAddons);
})(typeof window === 'undefined' ? globalThis : window, function () {
  'use strict';
  const managed = (line) => !!line.properties._pictomini_addon_product && ['design', 'order'].includes(line.properties._pictomini_addon_scope);
  function plan(cart, quantities, engine, removeKey) {
    if (!engine || typeof engine.planParentChange !== 'function' || typeof engine.planOrderServices !== 'function') throw new Error('cartUnavailable');
    const updates = Object.create(null);
    for (const line of cart.items) {
      const raw = String(quantities[line.key] ?? line.quantity);
      if (!/^\d+$/.test(raw) || !Number.isSafeInteger(Number(raw))) throw new Error('invalidQuantity');
      updates[line.key] = managed(line) ? line.quantity : Number(raw);
    }
    // Keep the original snapshot for parent identity checks, and apply all user edits
    // before asking the engine about order-scoped services.
    const working = { ...cart, items: cart.items.map((line) => ({ ...line, quantity: updates[line.key] })) };
    for (const line of cart.items) {
      if (managed(line) || updates[line.key] === line.quantity) continue;
      const result = engine.planParentChange(cart, line.key, updates[line.key]);
      if (result.warning) throw new Error(result.warning);
      for (const [key, quantity] of Object.entries(result.updates)) if (Object.hasOwn(updates, key)) updates[key] = quantity;
    }
    // An explicit service removal never removes its parent.
    if (removeKey && cart.items.some((line) => line.key === removeKey && managed(line))) updates[removeKey] = 0;
    // Normalize order services from the complete final state, including multi-parent edits.
    if (typeof engine.planOrderServices === 'function') {
      working.items.forEach((line) => { line.quantity = updates[line.key]; });
      const result = engine.planOrderServices(working);
      if (result.warning) throw new Error(result.warning);
      for (const [key, quantity] of Object.entries(result.updates)) if (Object.hasOwn(updates, key) && key !== removeKey) updates[key] = quantity;
    }
    return updates;
  }
  function mount(doc, getEngine) {
    const init = () => doc.querySelectorAll('[data-pm-linked-cart]').forEach((form) => {
      if (form.dataset.linkedReady) return;
      form.dataset.linkedReady = 'true';
      const rows = [...form.querySelectorAll('[data-cart-line-key]')];
      const cart = { items: rows.map((row) => ({ key: row.dataset.cartLineKey, quantity: Number(row.dataset.cartQuantity), handle: row.dataset.cartHandle, product_id: row.dataset.cartProduct, properties: { _pictomini_design_id: row.dataset.cartDesign, _pictomini_addon_product: row.dataset.cartAddonProduct, _pictomini_addon_scope: row.dataset.cartScope, _pictomini_parent_design: row.dataset.cartParent } })) };
      cart.item_count = cart.items.reduce((sum, line) => sum + line.quantity, 0);
      const error = form.querySelector('[data-cart-links-error]');
      let removeKey = null;
      form.addEventListener('submit', (event) => {
        try {
          const values = Object.fromEntries(rows.map((row) => [row.dataset.cartLineKey, row.querySelector('[name="updates[]"]').value]));
          const updates = plan(cart, values, getEngine(), removeKey);
          rows.forEach((row) => { row.querySelector('[name="updates[]"]').value = updates[row.dataset.cartLineKey]; });
          error.hidden = true;
          // Allow this same native form POST to retain its update/checkout submitter.
        } catch (_) {
          event.preventDefault();
          error.hidden = false;
          error.focus();
        }
        removeKey = null;
      });
      form.addEventListener('click', (event) => {
        const remove = event.target.closest('[data-cart-linked-remove]');
        if (!remove || !form.contains(remove)) return;
        event.preventDefault();
        const row = remove.closest('[data-cart-line-key]');
        removeKey = row.dataset.cartLineKey;
        row.querySelector('[name="updates[]"]').value = '0';
        form.requestSubmit(form.querySelector('[name="update"]'));
      });
    });
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
    doc.addEventListener('shopify:section:load', init);
  }
  return { plan, managed, mount };
});

